'use client'

import { useBookSearchSortBy } from '@hermes/search'
import { Chevron, MenuItem, Typography } from '@hermes/web-components'
import { useAnalytics } from '@lib/contexts/analyticsContext'
import { getI18nLabelToSortOption } from '@lib/utils/searchEngineHelpers'
import { useCallback } from 'react'
import { SortByAttribute } from '@hermes/api-sdk'
import { MenuPaperStyles, Selector, SelectorLabel } from './SearchSelector.styles'

const Label = ({ labelValue }: { labelValue?: string }) => (
  <SelectorLabel>
    <Typography fontSize="16px" lineHeight="20px" fontWeight="400">
      {labelValue}
    </Typography>
  </SelectorLabel>
)

export const SortSearchSelector = () => {
  const analytics = useAnalytics()
  const { sortingOptions, setSorting, currentSortOption } = useBookSearchSortBy()
  const handleChange = (value: SortByAttribute) => {
    if (typeof value === 'string') {
      analytics.trackEvent('SEARCH_SORTING_UPDATED', {
        sort: value
      })
      setSorting({ value })
    }
  }

  const localisedSortOption = useCallback((arg: any) => getI18nLabelToSortOption(arg?.value), [currentSortOption])

  return (
    <Selector
      value={localisedSortOption(currentSortOption)}
      MenuProps={{
        PaperProps: { sx: MenuPaperStyles }
      }}
      IconComponent={Chevron}
      renderValue={() => <Label labelValue={localisedSortOption(currentSortOption)} />}
      onChange={(event) => handleChange(event.target.value as SortByAttribute)}
    >
      {sortingOptions.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          <Typography fontWeight={500} fontSize="14px" lineHeight="20px">
            {localisedSortOption(option)}
          </Typography>
        </MenuItem>
      ))}
    </Selector>
  )
}
